module.exports = __webpack_public_path__ + "static/map-dark-16179e3731a1a7ac318cccba65401224.svg";